(() => {
  const body = document.body;
  const launcher = document.querySelector('.rosarium-whatsapp-launcher');
  if (!body || !launcher) return;

  const productRowSelector = [
    'main .product-list-section .resource-list',
    'main .product-grid-container',
    'main .product-grid',
    'main product-recommendations',
    'main [data-testid="resource-list-grid"]',
  ].join(', ');

  let visible = false;
  let collapsed = false;
  let productObserver;
  let fallbackScrollHandler;
  let collapseScrollHandler;

  const collapse = () => {
    if (collapsed) return;

    collapsed = true;
    body.classList.add('rosarium-whatsapp-collapsed');

    if (collapseScrollHandler) {
      window.removeEventListener('scroll', collapseScrollHandler);
      collapseScrollHandler = undefined;
    }
  };

  const armCollapseOnScroll = () => {
    if (collapseScrollHandler || collapsed) return;

    let armed = false;
    let startScrollY = window.scrollY;

    window.setTimeout(() => {
      armed = true;
      startScrollY = window.scrollY;
    }, 700);

    collapseScrollHandler = () => {
      if (!armed) return;

      if (Math.abs(window.scrollY - startScrollY) >= 8) {
        collapse();
      }
    };

    window.addEventListener('scroll', collapseScrollHandler, { passive: true });
  };

  const reveal = () => {
    if (visible) return;

    visible = true;
    body.classList.remove('rosarium-whatsapp-pending');
    body.classList.add('rosarium-whatsapp-visible');
    armCollapseOnScroll();
    productObserver?.disconnect();

    if (fallbackScrollHandler) {
      window.removeEventListener('scroll', fallbackScrollHandler);
      fallbackScrollHandler = undefined;
    }
  };

  const firstProductRow = () => document.querySelector(productRowSelector);

  const watchProductRow = () => {
    const target = firstProductRow();
    if (!target) return false;

    if (!('IntersectionObserver' in window)) {
      reveal();
      return true;
    }

    productObserver?.disconnect();
    productObserver = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          reveal();
        }
      },
      {
        root: null,
        rootMargin: '0px 0px -18% 0px',
        threshold: 0.04,
      }
    );

    productObserver.observe(target);
    return true;
  };

  const installFallback = () => {
    if (fallbackScrollHandler) return;

    fallbackScrollHandler = () => {
      if (window.scrollY > window.innerHeight * 0.4) {
        reveal();
      }
    };

    window.addEventListener('scroll', fallbackScrollHandler, { passive: true });
  };

  const start = () => {
    if (watchProductRow()) return;

    window.setTimeout(() => {
      if (!watchProductRow()) {
        installFallback();
      }
    }, 1200);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
